<template>
  <div id="research" class="fixed-content">
    <page-section :header="require('@/assets/research.jpg')"
                title="Recherche">
      <div class="row">
        <div class="col-md-6 col-md-offset-3 col-sm-offset-2 col-sm-8 col-xs-12">
          <div class="panel panel-topCvp">
            <div class="panel-heading text-center">
              <h2 class="panel-title">
                <img class="img-responsive logo"
                     :src="require('@/assets/img/logo-topcvp.png')"/>
              </h2>
              <h4>
                Étude de l'impact des mesures de prévention<br>
                des bactériémies liées à un CVP
              </h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12">
                  <p class="text-justify">
                    L'inscription à TopCVP ainsi que les liens vers les différents formulaires
                    de l'étude sont accessibles depuis votre espace SPIADI.
                  </p>
                  <btn type="btn btn-lg btn-topCvp btn-block"
                       @click="$router.push('/establishments/list')">
                    Accéder à l'espace SPIADI
                  </btn>
                  <hr>
                  <div class="text-center">
                    <h4>Téléchargements</h4>
                  </div>
                  <ul>
                    <div v-for="(b, k) in sc.top.files"
                         :key="k">
                      <link-block :file="b.file"
                              :link="b.link"
                              :description="b.description"
                              :title="b.title"
                              class="fb-topCvp col-xs-12 col-md-6"
                              :text="b.text"
                              :icon="b.icon">
                      </link-block>
                      <div v-if="!((k + 1) % 2)" class="clearfix"></div>
                    </div>
                  </ul>
                </div>
              </div>
              <hr>
              <ul>
                <span v-for="(h, k) in sc.top.hfb"
                      :key="`echo-dc-${k}`">
                  <horizontal-feature-block :title="h.title"
                                            :texts="h.texts"
                                            class="hfb-topCvp col-xs-12"
                                            :icon="h.icon">
                  </horizontal-feature-block>
                  <div v-if="h.separator">
                    <div class="col-xs-3 text-center">
                      <span class="glyphicon txt-topCvp"
                            :class="`glyphicon-${h.separator.icon}`"
                            :style="h.separator.style">
                      </span>
                    </div>
                    <div class="col-xs-9">
                      <hr v-if="h.separator.hr">
                    </div>
                  </div>
                </span>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </page-section>
  </div>
</template>

<script>
import pageSection from '@/components/pagesection'
import horizontalFeatureBlock from '@/components/horizontalFeatureBlock'
import linkBlock from '@/components/linkBlock'
import videoFrame from '@/components/videoFrame'
import sc from '@/views/sc/research'

import { mapGetters } from 'vuex'

export default {
  name: 'research',

  data () {
    return {
      marker: {
        dc: 0
      },
      sc: sc
    }
  },

  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn'
    })
  },

  components: {
    pageSection,
    'horizontal-feature-block': horizontalFeatureBlock,
    'link-block': linkBlock,
    'video-frame': videoFrame
  },

  methods: {
    add () {
      this.$router.push('establishments')
    }
  }
}
</script>

<style scoped lang="less">
@import '~variables';

.feature-block-row {
    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max){
        .col-sm-4:nth-child(4n+1) {
            clear: both;
        }
    }
}

.btn-block {
  max-width: 40rem;
  margin-left: auto;
  margin-right: auto;
  white-space:normal !important;
  word-wrap: break-word;
}

.feature-block {
    margin-bottom: 10rem;
}

ul {
    padding-left: 1rem;
    padding-right: 1rem;
}

h2.panel-title {
    font-size: 180%;
}

.logo {
  max-height: 12rem;
  margin: auto;
}
</style>
